import {
  GET_USERDETAILS,
  SET_USERDETAILS,
} from "../constants/user-details-constants";

export const getUserDetails = () => ({
  type: GET_USERDETAILS,
});

export const setUserDetails = (data) => ({
  type: SET_USERDETAILS,
  data,
});
